// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsOfUse_wrapper__2r4rK","header":"TermsOfUse_header__31ctR","body":"TermsOfUse_body__jSfOb"};